import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-7dab5e91");

const _hoisted_1 = ["innerHTML"];

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.iconSvg ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    innerHTML: $setup.iconSvg,
    class: "icon-svg-body"
  }, null, 8, _hoisted_1)) : _createCommentVNode("", true);
}